<!-- Add "scoped" attribute to limit CSS to this component only -->
<template src="./Container.html" />
<style src="./Container.css" scoped></style>

<script>
  import Map from '@/components/Map/Map'

  export default {
    name: 'Container',
    components: {
      Map
    },
    data() {
      return {
        msg: 'Vérifie la disponibilité des vélos et emplacements dans ta ville !',
        isTownSelected: false,
        townSelection: '',
        townList: ''
      }
    },
    mounted() {
      let self = this
      // TODO : ≠ API sources should be determmined at this point to fulfill the select tag (then the switch on API really called into map component)
      // get list of contract (=Town) from JCDecaux, only for country FR
      fetch(
        'https://api.jcdecaux.com/vls/v1/contracts?apiKey=e5a9732090f5d7729496de52668c5781ff0740d1'
      )
        .then(response => response.json())
        .then(jsonData => jsonData.filter(entry => entry.country_code === 'FR'))
        .then(jsonData => {
          jsonData.push({name: 'montpellier'})
          jsonData.sort((a, b) => (a.name < b.name ? -1 : 1))
          self.townList = jsonData
          // select town from local storage
          this.getLocalStorage()
        })
    },
    methods: {
      handleTownSelection() {
        this.isTownSelected = this.townSelection !== ''
        this.setLocalStorage()
      },
      setLocalStorage() {
        if (this.townSelection != null) {
          localStorage.setItem('townSelected', this.townSelection)
        }
      },
      getLocalStorage() {
        if (localStorage.getItem('townSelected') != null) {
          this.townSelection = localStorage.getItem('townSelected')
          this.isTownSelected = true
        }
      }
    }
  }
</script>
